import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import ForgetPassword from "@/views/ForgotPassword.vue";
import RegisterUser from "@/views/RegisterUser";
import Dashboard from "@/views/DashboardUser.vue";
import { useAuthStore } from "@/stores/auth";
import ReportUser from "@/components/ReportUser.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import DashboardArea from "@/views/DashboardArea.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: LoginView,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterUser,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgetPassword,
  },
  // --- صفحات داشبورد (با سایدبار) ---
  {
    path: "/",
    component: DashboardLayout, // layout فقط روی این بخش اعمال میشه
    meta: { requiresAuth: true }, // نیاز به لاگین
    children: [
      { path: "/", name: "Area", component: DashboardArea },
       { path: "/area", name: "Area", component: DashboardArea },
      { path: "/dashboard", name: "Dashboard", component: Dashboard },
      { path: "/report", name: "Report", component: ReportUser },
    ],
  },
  /*
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
     meta: { requiresAuth: true }, // صفحه محافظت شده
  },
   {
    path: "/report",
    name: "Report",
    component: ReportUser,
     meta: { requiresAuth: true }, // صفحه محافظت شده
  },*/
  // مسیرهای دیگر مثل داشبورد یا ... بعداً اضافه می‌کنی
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isLoggedIn;

  // مسیرهایی که نیاز به لاگین دارن
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ path: "/login" });
  }
  // اگر کاربر لاگین هست و می‌خواد login بره → هدایت به dashboard
  else if (to.path === "/login" && isAuthenticated) {
    next({ path: "/area" });
  }
  // مسیر اصلی "/" → اگر صفحه خانه ندارید، هدایت به login
  else if (to.path === "/" && isAuthenticated) {
    next({ path: "/area" });
  } else {
    next();
  }
});

export default router;
